import InternalStaticAnchorPrizeList from 'models/application/anchor/types/internalStatic/types/PrizeList';

export default class InternalStaticAnchorPrizeListService {
	toModel(anchor) {
		return new InternalStaticAnchorPrizeList(anchor);
	}
}
